import { FaReddit } from "react-icons/fa6";
import { type SocialPlatformBaseSettings } from "./types";

export const redditBaseSettings: SocialPlatformBaseSettings = {
  name: "Reddit",
  icon: FaReddit,
  fields: {
    title: "required",
    caption: "optional", // Body of text post or comment on link/media
    linkAttachment: "optional",
    userTags: "optional", // In body/comments
    // Flairs are important - handle separately?
  },
  limits: {
    // Limits depend heavily on post type
  },
  notes: [
    "Requires selecting a subreddit.",
    "Post types dictate fields/limits.",
  ],
  postTypes: {
    text_post: {
      nameSuffix: " Text Post",
      fields: { caption: "required", linkAttachment: "not_allowed" },
      limits: { caption: 40000, images: 0, videos: 0 },
    },
    link_post: {
      nameSuffix: " Link Post",
      fields: { caption: "not_allowed", linkAttachment: "required" }, // Title + Link = post
      limits: { images: 0, videos: 0 },
    },
    media_post: {
      nameSuffix: " Media Post",
      fields: { caption: "optional", linkAttachment: "not_allowed" },
      limits: { images: 1, videos: 1 }, // Or gallery (multiple images)
      notes: ["Can be single image/video or gallery."],
    },
  },
};
